import React from "react";

function LikeButton({ onClick, isLiked, fontSize }) {
  return (
    <div
      onClick={onClick}
      className={` text-[${fontSize}] z-40 h-[25px] w-[25px] flex justify-center items-center rounded-full active:bg-gray-600/50`}
    >
      {!isLiked ? (
        <span className="text-gray-400">
          <i className="bi-heart"></i>
        </span>
      ) : (
        <span className="text-red-400">
          <i className="bi-heart-fill"></i>
        </span>
      )}
    </div>
  );
}

export default LikeButton;
